<template>
  <div class="goods_detail" v-loading="is_Empty(goods)">
    <!-- 图片等信息 -->
    <div class="top fr mb20">
      <div class="left">
        <pre-view :imgs="goods.goodsImgBeans"
                  :img="is_Empty(goods.goodsSpecificationBeans) ? '' :currentSpecification.specification_img"/>
        <div
            class="fr ac cursor mt20 fz14"
            @click="insertCollection"
            :class="{blue:goods.is_collection == 1,black:goods.is_collection != 1}"
        >
          <i class="fz18 el-icon-star-off" v-if="goods.is_collection != 1"/>
          <i class="fz18 el-icon-star-on" v-else/>
          <span class="ml10">收藏产品</span>
        </div>
      </div>
      <div class="right">
        <div>
          <p class="fz16 ellipsis-2line">{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
          <img src="/static/imgs/promotion.png" v-if="Number(goods.is_promote) === 1" class="promotion"/>
        </div>
        <div class="brief mb20">
          <div class="fr ac" v-if="!is_Empty(goods.goodsSpecificationBeans)">
            <div class="fr top ac mr30">
              <p class="fz16 black">{{ isItSale ? '展示价：' : '价格:' }}</p>
              <span class="fz16 orange">￥{{ currentSpecification.show_price }}</span>
              <span class="fz16 black">/{{ currentSpecification.price_unit }}</span>
            </div>
            <div class="fr top ac mr30" v-if="isItSale">
              <p class="fz16 black">基准价:</p>
              <span class="fz16 orange">￥{{ currentSpecification.specification_price }}</span>
              <span class="fz16 black">/{{ currentSpecification.price_unit }}</span>
            </div>
            <div class="fr top ac mr30" v-if="isShowWholesalePrice && Number(currentSpecification.wholesale_price)">
              <p class="fz16 black">批发价:</p>
              <span class="fz16 orange">￥{{ currentSpecification.wholesale_price }}</span>
              <span class="fz16 black">/{{ currentSpecification.price_unit }}</span>
            </div>

          </div>
          <div class="bottom fr ac jsa">
            <div class="fc ac jc">
              <span class="fz14 grey">{{ goods.goods_assessment }}%</span>
              <span class="fz12 mt10 grey">最多人选用</span>
            </div>
            <div class="fc ac jc">
              <span class="fz14 grey">{{ goods.goods_life }}月</span>
              <span class="fz12 mt10 grey">预估寿命</span>
            </div>
          </div>
        </div>
        <el-alert
            v-if="goods.goods_warn"
            :title="`温馨提示：${goods.goods_warn}`"
            type="warning" :closable="false" class="mb10">
        </el-alert>
        <el-form label-position="top" size="small">
          <el-form-item label="所属行业">
            <p>
              {{
                `${filterByIndustryName.industry_name1}/${filterByIndustryName.industry_name2}/${filterByIndustryName.industry_name3}`
              }}</p>
          </el-form-item>
          <el-form-item label="规格参数">
            <p
                class="spec-item fz10 cursor"
                v-for="(i,k) in goods.goodsSpecificationBeans"
                :key="i.specification_id"
                :class="{active:k === specification_index,'specification-disabled':isDisabled(i)}"
                @click="isDisabled(i)?'':selectSpecification(k,i.specification_id)"
            >{{ i.specification_name }}
            </p>
          </el-form-item>
          <div v-if="isShowWholeInfo">
            <el-alert
                v-if="whetherTheWholesalePriceIsMet"
                title="温馨提示：当前购买数量已享受批发价。"
                type="success" :closable="false" class="mb10">
            </el-alert>
            <el-alert
                v-else
                :title="`温馨提示：${isShowWholeInfo}`"
                type="warning" :closable="false" class="mb10">
            </el-alert>
          </div>
          <el-form-item :label="`请输入尺寸（${currentSpecification.priceModelBean.factors_unit}）`"
                        v-if="!is_Empty(goods_specification_input) && !is_Empty(currentSpecification)">
            <div class="fr ac">

              <div class="fr ac mr10" v-for="i in inputList" :key="i.key">
                <el-tooltip class="item" effect="dark" :content="enterALimit(i)" placement="top-start">
                  <p>{{ i.label }}
                    <i class="el-icon-question"></i>
                    ：</p>
                </el-tooltip>
                <el-input-number
                    v-model="input_form[i.key]"
                    @change="handleDimensionChange(i.key)"
                    controls-position="right"
                    :min="i.min" :max="i.max"/>
              </div>
            </div>
            <el-form-item label="库存信息" v-show="show_inventory">
              <!-- 有库存信息时 -->
              <div v-if="inventoryList && inventoryList.length > 0" class="inventory-list ">
                <div
                    v-for="(item, index) in inventoryList"
                    :key="index"
                    class="inventory-item"
                >
                  <div class="inventory-info">
                    <span class="fz14">库存{{ index + 1 }}</span>
                    <span class="fz12 grey ml10" v-if="item.productFeature2">(宽幅：{{ item.productFeature2 }})</span>
                  </div>
                  <div class="inventory-stock fr ac">
                    <span class="fz14">现存量：{{ item.baseOnHandQty }}</span>
                  </div>
                </div>
              </div>
              <!-- 无库存信息时 -->
              <div v-else class="inventory-list">
                <el-alert
                    title="无匹配的库存信息，您仍可继续下单。"
                    type="warning" :closable="false" class="mb10">
                </el-alert>
              </div>

            </el-form-item>
          </el-form-item>
          <el-form-item label="选择配套工艺">
            <div class="fr ac process jsb cursor" @click="visible = true">
              <span>{{ crafts_arr.length ? `已选择${crafts_arr.length}项工艺` : "请选择配套工艺" }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-form-item>
          <el-form-item label="请选择设备">
            <el-cascader
                size="small"
                clearable
                v-model="device_id"
                :options="company_device_list"
                :props="{value:'company_device_id',label:'company_device_name',children:'companyDevicePositionBeans'}"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="设备备注" v-if="deviceRemark"> {{ deviceRemark }}</el-form-item>
          <el-form-item label="数量">
            <el-input-number size="mini" controls-position="right" v-model="car_num" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item label="图纸">
            <upload-img :file_list.sync="file_list" file_type="image/*"/>
          </el-form-item>
          <el-form-item label="特殊要求" v-if="require_ment_list.length">
            <el-checkbox-group v-model="checkList">
              <el-checkbox :label="i" v-for="i in require_ment_list" :key="i.id">{{ i.content }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div class="fr ac jsa">
          <el-button
              type="primary"
              icon="el-icon-shopping-cart-1"
              size="small"
              @click="checkedSelect(1)"
          >加入购物车
          </el-button>
          <el-button type="warning" size="small" @click="checkedSelect(2)">立即购买</el-button>
        </div>
      </div>
    </div>
    <!-- 商品详情，评价，推荐商品 -->
    <div class="main fr afs">
      <div class="left">
        <div class="main-nav fr fz14">
          <div
              class="nav-item fr ac jc black cursor"
              :class="{active:active == 1}"
              @click="active = 1"
          >商品详情
          </div>
          <div
              class="nav-item fr ac jc black cursor"
              :class="{active:active == 2}"
              @click="active = 2"
          >累计评论（{{ goods.assessment_count || total || 0 }}）
          </div>
        </div>
        <div class="pl20 pr20 pb20 goods-desc pt20 fc ac " v-show="active == 1">
          <el-row class="label-box">
            <el-col class="label-item" :xs="8" :sm="8" :md="8" :lg="4" :xl="6" v-for="i in labelList" :key="i.label_id">
              <h2>{{ i.label_name }}:</h2>
              <div class="label-box-content">
                  <span v-for="(j,k) in i.labelBeans" :key="j.label_id">{{
                      j.label_name
                    }}{{ k === i.labelBeans.length - 1 ? '' : '、' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="craft-preview-box">
            <el-col class="craft-item" :xs="8" :sm="8" :md="8" :lg="4" :xl="8" v-for="i in craftList" :key="i.craft_id">
              <div class="craft-title">
                <h3 class="ellipsis-2line">{{ i.craft_name }}</h3>
              </div>
              <img class="craft-image" :src="i.craft_images[0]" :title="i.craft_name"/>
            </el-col>
          </el-row>
          <p v-html="goods.goods_url_desc"></p>
        </div>

        <div v-show="active == 2" class="pl20 pr20 pt20">
          <evaluate-cell v-for="(i,k) in evaluate_list" :key="k" :info="i"/>
          <!-- 底部分页 -->
          <div class="fr ac jc">
            <el-pagination
                :hide-on-single-page="true"
                small
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                background
                class="mt20 mb20"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="right" v-if="$store.state.recommendGoodsList.length">
        <div class="main-nav fr ac pl20">
          <p class="fz14 black bold">为您推荐</p>
        </div>
        <div class="pl20 pt10 pr20">
          <col-cell v-for="i in $store.state.recommendGoodsList" :key="i.goods_id" :goods="i"/>
        </div>
      </div>
    </div>
    <!-- 选择配套工艺 -->
    <select-craft
        v-if="!is_Empty(goods)"
        :is_add="true"
        :show.sync="visible"
        :length="input_form['goods_length']"
        :width="input_form['goods_width']"
        :select_craft_list.sync="crafts_arr"
        :craft_remark.sync="craft_remark"
        :goods_id="goods.goods_id"
    />
  </div>
</template>

<script>
import PicZoom from "@/components/PicZoom";
import PreView from "./PreView";
import EvaluateCell from "@/components/EvaluateCell";
import ColCell from "@/components/ColCell";
import UploadImg from "@/components/UploadImg";
import {getStock} from "../../../api/shop";

export default {
  data() {
    return {
      input_form: {},
      inputKey: {
        "goods_length": "长度",
        "goods_width": "宽度",
        "weight": "重量"
      },
      file_list: [], //图纸
      visible: false,
      show_inventory: false,
      debounceTimer: null,
      goods: {}, //商品详情
      devices: [], //设备信息
      device_id: [],
      craft_remark: "", //其他技术要求
      car_num: 1,
      specification_id: null,
      active: 1,
      goods_length: null,
      goods_width: null,
      weight: null,
      price: {},
      company_info: {},
      evaluate_list: [],
      labelList: [],
      craftList: [],
      crafts_arr: [],
      total: 0,
      page: 1,
      company_device_list: [],
      industry_list: [],
      require_ment_list: [],
      checkList: [],
      inventoryList: [],
      specification_index: 0,
      goods_specification_input: []
    };
  },
  created() {
    this.getGoodsDetail();
    this.getCompanyDetail();
    this.getCompanyDeviceList();
    this.getGoodsAssessments();
    this.getIndustrys();
    this.getCompanyRecommendGoodsList();
    if (this.hasMemberType(2)) {
      this.getCompanyRequirementList()
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route(to, from) {
      this.getGoodsDetail();
    },
    page(n) {
      this.getGoodsAssessments();
    },
  },
  computed: {

    // 客户归属是否为经销商
    // 如果客户为经销商，则只能下单供应商商品。
    companyIsMiddleman() {
      if (this.is_Empty(this.company_info)) return false;
      return this.company_info.source === 'middleman';
    },
    whetherTheWholesalePriceIsMet() {
      if (!this.isShowWholesalePrice) return false;
      let o = {
        1: this.input_form.goods_length,
        2: this.input_form.goods_length,
        3: this.input_form.weight,
        '-1': this.car_num
      }
      let value = o[this.currentSpecification.priceModelBean.id];
      return isNaN(value) ? 0 : Number(value) >= Number(this.currentSpecification.wholesale_price_min_quantity);
    },
    isShowWholeInfo() {
      if (!this.isShowWholesalePrice) return '';
      let {wholesale_price_min_quantity, priceModelBean, wholesale_price} = this.currentSpecification;
      if (this.is_Empty(wholesale_price_min_quantity) || Number(wholesale_price_min_quantity) === 0 || this.is_Empty(wholesale_price)) return '';
      let o = {
        1: "长度",
        2: "长度",
        3: "重量",
        '-1': '数量'
      }
      return `${o[priceModelBean.id]}${wholesale_price_min_quantity}${priceModelBean.factors_unit}以上才能享受批发价`
    },
    isShowWholesalePrice() {
      return true;
      if (!this.isItSale) return false;
      let company_info = this.company_info;
      if (this.is_Empty(company_info)) return false;
      return company_info.source === 'middleman';
    },
    //是否展示展示价
    isItSale() {
      return (!this.is_Empty(this.$store.state.sale_info) || this.$store.state.is_sales);
    },
    inputList() {
      if (this.is_Empty(this.goods_specification_input)) return [];
      let list = []
      this.goods_specification_input.forEach(el => {
        let currentRange = this.inputRange[el];
        let o = {
          label: this.inputKey[el],
          key: el,
          min: 0.01,
          max: Infinity,
        }
        if (!this.is_Empty(currentRange)) {
          let min = Number(currentRange.min);
          let max = Number(currentRange.max);
          o.min = min === 0 ? 0.01 : min;
          o.max = max === 0 ? Infinity : max;
        }
        list.push(o)
      })
      return list;
    },
    //当前选择的规格
    currentSpecification() {
      if (this.is_Empty(this.goods)) return {};
      if (this.is_Empty(this.goods.goodsSpecificationBeans)) return {};
      return this.goods.goodsSpecificationBeans[this.specification_index];
    },

    //输入范围限制
    inputRange() {
      if (this.is_Empty(this.goods)) return {};
      if (this.is_Empty(this.goods.goodsSpecificationBeans)) return {};
      if (this.is_Empty(this.currentSpecification.input_range)) return {};
      let o = {};
      this.currentSpecification.input_range.forEach(el => {
        o[el.input_name] = el;
      })
      return o;
    },
    filterByIndustryName() {
      let industryList1, industryList2, children = [];
      let {industry_id1, industry_id2, industry_id3} = this.goods;
      let industryName = {
        industry_name1: "",
        industry_name2: "",
        industry_name3: "",
      }
      try {
        if (this.is_Empty(industry_id1)) return industryName;
        industryList1 = this.industry_list.find(e => e.industry_id == industry_id1)
        industryName.industry_name1 = industryList1.industry_name
        if (this.is_Empty(industry_id2)) return industryName;

        industryList2 = industryList1.insustryBeans.find(e => e.industry_id == industry_id2)
        industryName.industry_name2 = industryList2.industry_name
        if (this.is_Empty(industry_id3)) return industryName;
        children = industryList2.insustryBeans.filter(e => industry_id3.includes(e.industry_id));
        industryName.industry_name3 = [];
        children.forEach(el => {
          industryName.industry_name3.push(el.industry_name)
        })
        industryName.industry_name3 = industryName.industry_name3.join(",")
        return industryName;
      } catch (e) {
        return industryName;
      }
    },
    deviceRemark() {
      if (this.is_Empty(this.device_id)) return "";
      let obj = this.company_device_list.find(el => el.company_device_id == this.device_id[0]);
      return this.is_Empty(obj) ? '' : obj.remarks;
    },

  },
  methods: {
    enterALimit(i) {
      if (this.is_Empty(i)) return '';
      if (i.min === -Infinity && i.max === Infinity) return "输入无限制";
      if (i.min === -Infinity && i.max !== Infinity) return `输入小于${i.max}`;
      if (i.min !== -Infinity && i.max === Infinity) return `输入大于${i.min}`;
      return `输入在${i.min}到${i.max}之间`;
    },
    isDisabled(i) {
      return Number(i.specification_price) <= 0;
    },

    getIndustrys() {
      this.post("goodsInterfaces/v1.0/getIndustrys", {}).then(res => {
        this.industry_list = res.data;
      })
    },
    //   获取客户特殊要求列表
    getCompanyRequirementList() {
      this.post("companyRequirement/getCompanyRequirementList", {}).then((res) => {
        this.require_ment_list = res.data;
      });
    },
    // 选择
    selectSpecification(index, specification_id) {
      let goods = Object.assign({}, this.goods);
      goods.goodsSpecificationBeans.forEach(el => {
        if (el.specification_id === specification_id) {
          this.goods_specification_input = this.is_Empty(el.priceModelBean) ? [] : el.priceModelBean.factors
        }
      });
      this.goods = Object.assign({}, goods);

      this.specification_index = index;
    },
    checkedSelect(type) {

      if (this.is_Empty(this.goods.shop_id) && this.companyIsMiddleman) {
        this.$message("经销商请选择供应商商品下单！");
        return;
      }
      if (this.is_Empty(this.device_id) && !this.is_Empty(this.company_device_list)) {
        this.$confirm('当前商品未选择设备，请确认。', '温馨提示', {
          confirmButtonText: "确认不选择",
          cancelButtonText: "去选择设备",
          type: 'warning'
        })
            .then(() => {
              this.addCart(type);
            })
            .catch(() => {
              // on cancel
            });
      } else {
        this.addCart(type);
      }
    },
    handleDimensionChange(type) {
      // console.log(type)
      let list = ['goods_length', 'goods_width'];
      // 去除长宽以外的其他输入信息
      if (!list.includes(type)) return;

      // 根据长宽输入信息，判断是否填写完成。
      let isRequest = list.filter(el => this.is_Empty(this.errorMessage(el)))
      if (isRequest.length !== 2) {
        this.show_inventory = false;
        return;
      }
      // 清除之前的计时器
      clearTimeout(this.debounceTimer)

      this.debounceTimer = setTimeout(this.getHycStock, 800) // 800ms防抖延迟
    },
    getHycStock() {
      let params = {
        goods_name: this.goods.goods_standard_name,
      }
      this.goods_specification_input.forEach(e => {
        params[e] = this.input_form[e];
      })


      getStock(params).then(res => {
        this.inventoryList = res.data;
        this.show_inventory = true;
      })
    },
    errorMessage(k) {
      let value = this.input_form[k];
      if (this.is_Empty(value)) return `请输入${this.inputKey[k]}`;
      let {max = 0, min = 0} = this.inputRange[k] || {};
      if (this.is_Empty(value) || Number(value) === 0) {
        return `请输入${this.inputKey[k]}`
      }
      max = Number(max);
      min = Number(min);
      if (max === 0 && min === 0) return '';
      if (min > value || max < value) {
        return `${this.inputKey[k]}请输入${min}~${max}之间的数字`
      }
      return '';
    },
    // 添加购物车及立即购买
    addCart(type) {
      try {
        if (!this.hasMemberType(2)) {
          this.$message({
            type: "warning",
            message: "申请成为客户才能购买商品，暂无权限。",
          });
          return;
        }
        let message = '';
        this.goods_specification_input.some(el => {
          let m = this.errorMessage(el);
          if (m) {
            message = m;
            return true;
          }
          return false;
        });
        if (message) {
          this.$message.warning(message);
          return;
        }
        let obj = {};
        let current_select_specification = this.currentSpecification;
        obj.goods_id = this.goods.goods_id;
        obj.goods_type = this.goods.goods_type;
        obj.car_num = this.car_num;
        obj.goods_name = this.goods.goods_name;
        obj.car_num = this.car_num;
        obj.drawings = this.arrToStr(this.file_list)
        obj.specification_id = current_select_specification.specification_id
        obj.craft_remark = this.craft_remark || "";
        obj.company_requirement_json = [];
        if (!this.is_Empty(this.checkList)) {
          obj.craft_remark += '  特殊要求:';
          this.checkList.forEach(el => {
            obj.company_requirement_json.push({
              content: el.content,
              images: el.images,
            })
            obj.craft_remark += `${el.content}、`
          })
        }
        if (!this.is_Empty(this.device_id)) {
          obj.company_device_id = this.device_id[0];
          obj.company_device_position_id = this.device_id[1];
        }

        obj.goods_img = current_select_specification.specification_img || "";
        obj.specification_name = current_select_specification.specification_name;
        obj.price_unit = current_select_specification.price_unit;
        obj.specification_unit = current_select_specification.specification_unit;
        obj.goods_price = current_select_specification.show_price;

        obj.specification_inputs = [];
        this.goods_specification_input.forEach(e => {
          obj[e] = this.input_form[e];
          let o = {
            input_name: e,
            input_value: this.input_form[e]
          }
          obj.specification_inputs.push(o);
        })

        obj.crafts = this.crafts_arr || [];
        if (type === 1) {
          obj.specification_inputs = JSON.stringify(obj.specification_inputs)
          obj.crafts = JSON.stringify(obj.crafts);
          obj.company_requirement_json = JSON.stringify(obj.company_requirement_json);
          // 加入购物车
          this.post("carInterfaces/v1.0/insertCarV2", obj).then((res) => {
            if (res.msg === "ok" && res.status === "ok") {
              this.crafts_arr = [];
              this.craft_remark = "";
              this.$message.success("已添加购物车");
            }
          });
        } else {
          // 进入确认订单页面。
          this.$store.commit('setInsertOrder', [obj])
          this.go("confirm?type=detail");
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取商品详情
    async getGoodsDetail() {
      let res = await this.post("goodsInterfaces/v1.0/getGoodsDetail", {
        goods_id: this.$route.query.id,
      })
      let obj = res.data;
      let isSales = (!this.is_Empty(this.$store.state.sale_info) || this.$store.state.is_sales);
      obj.goodsSpecificationBeans.forEach(el => {
        if (el.priceModelBean) {
          el.priceModelBean.factors = this.strToArr(el.priceModelBean.factors);
        }
        el.input_range = this.is_Empty(el.input_range) ? [] : JSON.parse(el.input_range);
      })

      let spec = obj.goodsSpecificationBeans[0];
      this.goods_specification_input = this.is_Empty(spec.priceModelBean) ? [] : spec.priceModelBean.factors;
      let labelIds = obj.label_ids.split(",").map(Number);
      if (labelIds.length) {
        let labelList = await this.post("goodsInterfaces/v1.0/getGoodsLabels", {});
        labelList = labelList.data;
        let o = [];
        labelList.forEach(el => {
          let list = el.labelBeans.filter(e => labelIds.indexOf(e.label_id) !== -1);
          if (list.length) {
            o.push({
              ...el,
              labelBeans: list
            })
          }
        })
        this.labelList = o;
      }
      //获取所有带图片的工艺信息
      res = await this.post("goodsInterfaces/v1.0/getGoodsCraftImages", {goods_id: this.$route.query.id})
      let arr = res.data;
      arr.forEach(el => {
        el.craft_images = el.craft_images.split(",");
      })
      this.craftList = res.data;
      this.goods = this.deepClone(obj);
    },
    // 收藏产品
    insertCollection() {
      this.post("collectionInterfaces/v1.0/insertCollection", {
        collection_id: this.goods.goods_id,
        collection_type: 1,
      }).then((res) => {
        this.getGoodsDetail();
      });
    },
    //获取客户推荐商品
    getCompanyRecommendGoodsList() {
      if (!this.$store.state.is_company) return;
      if (this.$store.state.recommendGoodsList.length) return;
      this.post("goodsInterfaces/v1.0/getCompanyRecommendGoodsList", {}).then(res => {
        this.$store.commit("SET", {
          key: "recommendGoodsList",
          value: res.data
        })
      })
    },
    //获取公司信息
    getCompanyDetail() {
      this.post("companyInterfaces/v1.0/getCompanyDetail", {}).then(res => {
        this.company_info = res.data;
      });
    },
    // 获取设备
    getCompanyDeviceList() {
      this.post("companyInterfaces/v1.0/getCompanyDeviceList").then((res) => {
        if (res.status == "ok") {
          let list = res.data;
          list.forEach(el => {
            let name = el.company_device_name;
            if (!this.is_Empty(el.deviceBean)) {
              name = `${el.deviceBean.device_name}(${name})`
            }
            el.company_device_name = name;
            el.disabled = this.is_Empty(el.companyDevicePositionBeans)
            el.companyDevicePositionBeans.forEach(e => {
              e.company_device_name = e.position;
              e.company_device_id = e.id;
            })
          })
          this.company_device_list = list;
        }
      });
    },
    getGoodsAssessments() {
      this.post("goodsInterfaces/v1.0/getGoodsAssessments", {
        goods_id: this.$route.query.id,
        page: this.page,
      }).then((res) => {
        this.total = res.total;
        this.evaluate_list = res.data;
      });
    },
  },
  components: {
    "pic-zoom": PicZoom,
    PreView,
    EvaluateCell,
    ColCell,
    UploadImg,
  },
};
</script>

<style lang="scss">
.goods_detail {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  .promotion {
    //width: 50px;
  }

  .specification-disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .top {
    width: 100%;

    .left {
      width: 450px;
      background-color: #fff;
      padding: 20px;
    }

    .right {
      width: calc(100% - 470px);
      margin-left: 20px;
      background-color: #fff;
      padding: 20px;

      .process {
        width: 232px;
        line-height: 30px;
        font-size: 14px;
        border-bottom: 1px solid rgba(214, 214, 214, 1);
      }

      .brief {
        margin-top: 20px;
        width: 100%;
        background: rgba(225, 225, 225, 0.25);
        padding: 10px;

        .top {
          width: 100%;
          height: 40px;
        }

        .bottom {
          width: 100%;
          height: 60px;
          border-top: 1px solid #e5e5e5;
        }
      }

      .spec-item {
        display: inline-block;
        padding: 8px 15px;
        line-height: 20px;
        background: #dcdcdc;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
      }

      .active {
        background: rgba(69, 142, 246, 1);
        color: white;
      }

      .el-button {
        width: 200px;
        height: 44px;

        &:nth-of-type(2) {
          background-color: #fa6400;
          border-color: #fa6400;
        }
      }
    }
  }

  .main-nav {
    width: 100%;
    height: 40px;
    background-color: #e5e5e5;

    .nav-item {
      width: 200px;
      height: 100%;
    }

    .active {
      background-color: #fff;
      color: #458ef6;
    }
  }

  .main {
    width: 100%;


    .left {
      flex-grow: 1;
      //width: 67%;
      background-color: #fff;


      .goods-desc {
        padding-top: 20px;

        img {
          max-width: 100%;
        }
      }
    }

    .right {
      margin-left: 20px;
      width: calc(100% - 67% - 20px);
      background-color: #fff;
    }
  }

  .el-dialog {
    .el-dialog__header {
      background-color: #eaeaea;
      height: 40px;
      padding: 0 20px;

      .head {
        height: 100%;
      }
    }
  }

  .label-box {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    background-color: #eeeeee;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
    line-height: 30px;
    user-select: none;

    .label-item {
      padding: 20px;
      border-bottom: 1px solid #d4d5d5;
      border-right: 1px solid #d4d5d5;


      h2 {
        font-size: 22px;
        font-weight: bold;
      }

      .label-box-content {
        padding-top: 15px;
        min-height: 80px;
        color: #333;
        font-size: 18px;
      }
    }
  }

  .craft-preview-box {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    //cursor: pointer;
    user-select: none;

    .craft-item {
      padding: 10px;
      //width: 50%;

      .craft-title {
        height: 40px;
        margin: 10px 0;

        h3 {
          font-size: 16px;
          line-height: 18px;
        }
      }

      .craft-image {
        width: 100%;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);

      }
    }
  }
  .inventory-list {
    width: 400px;
    background-color: #F8F9FA;
    border-radius: 5px;

    .inventory-item {
      padding: 8px;
      border-bottom: 1px solid #E8E8E8;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .inventory-item:last-child {
      border-bottom: none;
    }

    .inventory-info {
      flex: 1;
    }

    .inventory-stock {
      display: flex;
      align-items: center;
      min-width: 80px;
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/goodsDetails/index.vue